<section class="w-full bg-neutral-gray-300 px-6 py-16">
  <div class="w-full mx-auto sm:flex sm:flex-col sm:items-center">
    <!-- Título de la sección -->
    <div class="flex flex-col gap-2 items-start justify-center text-left mb-10 sm:items-center">
      <h2 class="text-neutral-gray-900 text-2xl font-poppins font-semibold leading-tight m-0">
        Preguntas Frecuentes
      </h2>
      <p class="text-neutral-gray-600 font-poppins text-base font-normal leading-4 m-0">
        Encuentra la respuesta que necesitas
      </p>
    </div>

    <!-- Lista de preguntas -->
    <div class="flex flex-col gap-4 sm:w-[60%]">
      <div
        *ngFor="let faq of faqs"
        class="bg-neutral-gray-100 rounded-xl p-4 flex flex-col gap-3 cursor-pointer transition-all"
        (click)="toggleFAQ(faq)"
      >
        <!-- Pregunta con icono -->
        <div class="flex gap-3 items-center justify-between w-full">
          <p 
            class="text-neutral-gray-900 flex-1 m-0 font-poppins text-base font-semibold"
          >
            {{ faq.question }}
          </p>

          <!-- Icono chevron -->
          <div class="w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300" [class.rotate-180]="faq.isOpen">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6 9l6 6 6-6" stroke="#E62721" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <!-- Respuesta (visible cuando isOpen es true) -->
        <div
          *ngIf="faq.isOpen"
          class="text-neutral-gray-900 font-poppins font-normal leading-relaxed animate-fade-in"
          [innerHTML]="getFormattedAnswer(faq)"
        >
        </div>
      </div>
    </div>
  </div>
</section>
